<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path d="M9.3 5.5a1.2 1.2 0 0 1 1.2 1.2v2.6a1.2 1.2 0 0 1-1.2 1.2H6.7a1.2 1.2 0 0 1-1.2-1.2V6.7a1.2 1.2 0 0 1 1.2-1.2h2.6Z"/>
  <path fill="#fff" fill-opacity=".4" d="M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Zm0 1A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z"/>
</svg>